webpackJsonp([35783957827783],{

/***/ 307:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/andy-burnham_profile.47b77f06.jpg";

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/betway-banner.ce9ef9f1.jpg";

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/library-staircase.2139bf58.jpg";

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/young-boys-soccer.fe3b2587.jpg";

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This is the index page banner
	var Banner = function Banner(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "banner", className: "major index-banner" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "header",
	                { className: "betway-header" },
	                _react2.default.createElement(
	                    "h3",
	                    null,
	                    "Betaway enters the scene"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "content" },
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "Having partnered up with the PPF (the Professional Players Federation), an organisation body which is dedicated to the development, protection and promotion of professional sportsmen and women\u2019s collective interests across the UK."
	                ),
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "Betway is set to financially contribute to new educational initiatives that the organisation will be putting in place. Betway\u2019s support will come in the form of a long-term arrangement to assist in the funding of tutors and e-learning programmes which will allow for the delivery of critical athlete training."
	                ),
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "Betway\u2019s CEO expressed his excitement at joining the project, stating how much he was ",
	                    _react2.default.createElement(
	                        "a",
	                        { href: "http://www.igamingbusiness.com/news/betway-calls-clean-sports-betting-environment", "class": "highlight-link", target: "_blank", rel: "follow" },
	                        "looking forward to the sportsbook\u2019s opportunity to support"
	                    ),
	                    " the PPF\u2019s vital work both now and in the future."
	                )
	            )
	        )
	    );
	};
	
	exports.default = Banner;
	module.exports = exports["default"];

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This is the index page banner
	var BannerHome = function BannerHome(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "banner", className: "major index-banner2" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "header",
	                { className: "major" },
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Let me introduce myself"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "content" },
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "My name is Mike Hancock and I\u2019ve been born and bred in Portsmouth. As a journalist, I\u2019ve dedicated my career over the last 20 odd years to following the latest news and exploits of the local MPs and party representatives"
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: "actions" },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "a",
	                            { href: "/about", className: "button next" },
	                            "About Me"
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = BannerHome;
	module.exports = exports["default"];

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(307);
	
	__webpack_require__(308);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _BannerHome = __webpack_require__(201);
	
	var _BannerHome2 = _interopRequireDefault(_BannerHome);
	
	var _Banner = __webpack_require__(200);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _libraryStaircase = __webpack_require__(476);
	
	var _libraryStaircase2 = _interopRequireDefault(_libraryStaircase);
	
	var _youngBoysSoccer = __webpack_require__(482);
	
	var _youngBoysSoccer2 = _interopRequireDefault(_youngBoysSoccer);
	
	var _andyBurnham_profile = __webpack_require__(470);
	
	var _andyBurnham_profile2 = _interopRequireDefault(_andyBurnham_profile);
	
	var _betwayBanner = __webpack_require__(471);
	
	var _betwayBanner2 = _interopRequireDefault(_betwayBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeIndex = function (_React$Component) {
	    _inherits(HomeIndex, _React$Component);
	
	    function HomeIndex() {
	        _classCallCheck(this, HomeIndex);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    HomeIndex.prototype.render = function render() {
	        var siteTitle = this.props.data.site.siteMetadata.title;
	        var siteDescription = this.props.data.site.siteMetadata.description;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    siteTitle
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: siteDescription })
	            ),
	            _react2.default.createElement(_BannerHome2.default, null),
	            _react2.default.createElement(
	                'div',
	                { id: 'main' },
	                _react2.default.createElement(
	                    'section',
	                    { id: 'two', className: 'spotlights' },
	                    _react2.default.createElement(
	                        'section',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { to: '/generic', className: 'image' },
	                            _react2.default.createElement('img', { alt: '', src: _libraryStaircase2.default })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'inner' },
	                                _react2.default.createElement(
	                                    'header',
	                                    { className: 'major' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Failing Education'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'A recent quote from Stella Creasy, Labour MP expresses concerns that the nation\u2019s football team could well be',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://www.businessinsider.com/england-national-football-team-uk-great-britain-2018-6/', target: '_blank', rel: 'follow' },
	                                        ' underperforming due to a glut of players'
	                                    ),
	                                    ' coming from a private education background, raising concerns that talented players who come through the state school system are likely to be missed.'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'section',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'image' },
	                            _react2.default.createElement('img', { alt: '', src: _youngBoysSoccer2.default })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'inner' },
	                                _react2.default.createElement(
	                                    'header',
	                                    { className: 'major' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Pivately educated footballers'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    '13% of England\u2019s national team were privately educated \u2013 a figure which represents twice that of those who attend private school nationally. This suggests that there is an increasing problem of a narrowed focus on talent, with comprehensive schools being overlooked as a source of skilled players.'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'This statement, however, has been dismissed as irrelevant by Mr Redwood, Wokingham\u2019s MP, who supports the idea of developing more grammar schools specifically because of their ability to select young talent at an earlier age allowing them more time to hone their skills.'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'section',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'image' },
	                            _react2.default.createElement('img', { alt: '', src: _andyBurnham_profile2.default })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'inner' },
	                                _react2.default.createElement(
	                                    'header',
	                                    { className: 'major' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'The debate criticism'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Andy Burnham, our former shadow home secretary, who expressed his opposition to the idea of giving more schools the opportunity to select pupils. His opinion is that sports aren\u2019t really about life as a whole, and he cites the idea that labelling any child at the age of 11 as second rate is wrong.'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_Banner2.default, null),
	                _react2.default.createElement(
	                    'section',
	                    { id: 'three' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inner' },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'PPF\u2019s Educational Reach'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'image' },
	                            _react2.default.createElement('img', { className: 'betway-img', alt: 'betway-banner', src: _betwayBanner2.default })
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'The Chairman of the PPF also released a statement welcoming Betway to its partnership, pointing out the importance of athlete education and his delight in seeing a betting company offering its support to his company\u2019s most vital work. Thanks to the sportsbook\u2019s support, the PPF will be able to expand their educational reach, working productively in collaboration with the betting industry to enhance the reputation of the UK as a home of fair play, integrity and sporting excellence.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'It is hoped now that this most recent pairing of a sporting organisation and a sports betting company will lead to further projects of a similar nature to boost the educational profile of the UK\u2019s premier athletes and the rising stars and homegrown talent of the sporting community right across the nation and across a range of sporting sectors. '
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'It is hoped now that this most recent pairing of a sporting organisation and a sports betting company will lead to further projects of a similar nature to boost the educational profile of the UK\u2019s premier athletes and the rising stars and homegrown talent of the sporting community right across the nation and across a range of sporting sectors. '
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return HomeIndex;
	}(_react2.default.Component);
	
	exports.default = HomeIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-4c7e9b4b8b028be189e0.js